import { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import Chart from "react-apexcharts";

import { useSelector } from "react-redux";

import StatusCard from "../../components/status-card/DistributorStatusCard";

import Table from "../../components/table/Table";

import Badge from "../../components/badge/Badge";

import style from "./Dashboard.module.css";

import { useNavigate } from "react-router-dom";

import aeps from "../../assets/images/dashboard/open balance.svg";

import wallet from "../../assets/images/dashboard/top up receive.svg";

import balance from "../../assets/images/dashboard/total usages.svg";

import topUp from "../../assets/images/dashboard/closing balance.svg";

import { connect } from "react-redux";

import * as actionCreators from "../../redux/actions/reports";

import SelectWithSearch from "../../components/Commons/Select/SelectWithSearch";

import { toast } from "react-toastify";
import {
  apiFormatGet,
  apiFormatGetFullCtrl,
  apiFormatPost,
} from "../../Api/ApiFormat";

import * as DashboardactionCreators from "../../redux/actions/dashboard";

import WalletLoadIcon from "../../assets/images/wallet load.svg";
import WalletLoadPopup from "../../components/Distributor/WalletLoad/WalletLoadPopup/WalletLoadPopup";

import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import WhatNewPopup from "../../components/What'sNewPopup/WhatNewPopup";

const renderCusomerHead = (item, index) => <th key={index}>{item}</th>;

const renderCusomerBody = (item, index) => (
  <tr key={index}>
    <td>{item.username}</td>
    <td>{item.order}</td>
    <td>{item.price}</td>
  </tr>
);

const latestOrders = {
  header: [
    "#",
    "DATE",
    "TxnType",
    "Narration",
    "Amount",
    "Charges",
    "Commission",
    "GST",
    "TDS",
    "Balance",
  ],
};

const orderStatus = {
  shipping: "primary",
  pending: "warning",
  paid: "success",
  refund: "danger",
};

const renderOrderHead = (item, index) => <th key={index}>{item}</th>;

const renderOrderBody = (item, index) => (
  <tr key={index}>
    <td>{index + 1}</td>
    <td>{item.date ? item.date : "NA"}</td>
    <td>{item.TxnType ? item.TxnType : "NA"}</td>
    <td>{item.Naration ? item.Naration : "NA"}</td>
    <td>
      {item.TxnType === "MoneyTransfer" ||
        item.TxnType === "Verification" ||
        item.TxnType === "ScanAndPay" ||
        item.TxnType === "Recharge" ||
        item.TxnType === "PayRent" ? (
        <Badge
          type={"danger"}
          content={item.Amount || item.Amount === 0 ? item.Amount : "NA"}
        />
      ) : (
        <Badge
          type={"success"}
          content={item.Amount || item.Amount === 0 ? item.Amount : "NA"}
        />
      )}
    </td>
    <td>
      <Badge
        type={"danger"}
        content={item.charges || item.charges === 0 ? item.charges : "NA"}
      />
    </td>
    <td>
      <Badge
        type={"danger"}
        content={
          item.Commission || item.Commission === 0 ? item.Commission : "NA"
        }
      />
    </td>
    <td>
      <Badge
        type={"danger"}
        content={item.GST || item.GST === 0 ? item.GST : "NA"}
      />
    </td>
    <td>
      <Badge
        type={"danger"}
        content={item.TDS || item.TDS === 0 ? item.TDS : "NA"}
      />
    </td>
    <td>
      {item.TxnType === "Fund" || item.TxnType === "TopuP" ? (
        <Badge
          type={"success"}
          content={item.Balance || item.Balance === 0 ? item.Balance : "NA"}
        />
      ) : (
        <Badge
          type={"danger"}
          content={item.Balance || item.Balance === 0 ? item.Balance : "NA"}
        />
      )}
    </td>

    {/* <td>
            <Badge type={orderStatus[item.status]} content={item.status}/>
        </td> */}
  </tr>
);

const Dashboard = (props) => {
  const navigate = useNavigate();

  const themeReducer = useSelector((state) => state.ThemeReducer.mode);

  //status card data
  const statusCards = [
    {
      icon: aeps,
      count:
        props.DashboardData.dashboard.data &&
          props.DashboardData.dashboard.data.OpeningBal
          ? "₹ " + props.DashboardData.dashboard.data.OpeningBal
          : "₹ 0.00",
      title: "Opening Balance",
    },
    {
      icon: wallet,
      count:
        props.DashboardData.dashboard.data &&
          props.DashboardData.dashboard.data.TopUpReceived
          ? "₹ " + props.DashboardData.dashboard.data.TopUpReceived
          : "₹ 0.00",
      title: "Topup Received",
    },

    {
      icon: topUp,
      count:
        props.DashboardData.dashboard.data &&
          props.DashboardData.dashboard.data.ClosingBal
          ? "₹ " + props.DashboardData.dashboard.data.ClosingBal
          : "₹ 0.00",
      title: "Closing Balance",
    },
    // {
    //   icon: WalletLoadIcon,
    //   count: "",
    //   title: "Load Wallet",
    // },
  ];

  //onget ledger reports

  useEffect(() => {
    let neWDate = new Date();
    let DateObj;

    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };

    props.getLedgerReports(DateObj);
  }, [sessionStorage.getItem("userId")]);

  //chart options
  const [mapData, setMapData] = useState("");

  const chartOptions = {
    series: [
      mapData.AepsCount ? mapData.AepsCount : 0,
      mapData.DmtCount ? mapData.DmtCount : 0,
      mapData.PayRentCount ? mapData.PayRentCount : 0,
      mapData.RechargeCount ? mapData.RechargeCount : 0,
    ],
    chart: {
      type: "donut",
    },
    labels: [
      mapData.AepsCount ? "AEPS " + mapData.AepsCount : "AEPS 0",
      mapData.DmtCount ? "BBPS " + mapData.DmtCount : "BBPS 0",
      mapData.PayRentCount ? "PAYRENT " + mapData.PayRentCount : "PAYRENT 0",
      mapData.RechargeCount
        ? "RECHARGE " + mapData.RechargeCount
        : "RECHARGE 0",
    ],
    responsive: [
      {
        breakpoint: 640,
        options: {
          chart: {
            width: 390,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };
  const defaultchartOptions = {
    series: [0, 1, 0, 0],
    chart: {
      type: "donut",
    },
    labels: ["AEPS 0", "BBPS 0", "PAYRENT 0", "RECHARGE 0"],
    responsive: [
      {
        breakpoint: 640,
        options: {
          chart: {
            width: 390,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  const getPieChart = async (uid) => {
    let mapData = await apiFormatPost("/api/report/GetTranCountById", {
      UserId: uid,
    });
    if (mapData) {
      setMapData(mapData.data[0]);
    } else {
      toast.error("Something went wrong in fetching pie chart data!");
    }
  };
  let userId = sessionStorage.getItem("userId");

  //get retailer list by id
  const [retailersList, setRetailersList] = useState(false);
  const [retDetails, setRetDetails] = useState("");

  const getReatailersByID = async () => {
    let retailers = await apiFormatGet(
      "/api/Distributer/GetRetailerListById/",
      userId
    );

    if (retailers.data) {
      setRetailersList(retailers.data);

      if (retailers.data[0]) {
        setRetDetails(retailers.data[0]);
      }
    }
  };

  useEffect(() => {
    getReatailersByID();
  }, [userId]);

  useEffect(() => {
    if (retDetails) {
      getPieChart(retDetails.id);
    }
  }, [retDetails]);

  const [walletLoadPopup, setWalletLoadPopup] = useState(false);

  //refresh dashboard function

  const refreshDashBoardFunc = () => {
    props.onGetDashboard(navigate);
    getPieChart(retDetails.id);
    let neWDate = new Date();
    let DateObj;

    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };

    props.getLedgerReports(DateObj);
  };

  //update version
  const [showWhatNewPopup, setShowWhatNewPopup] = useState(false);
  const [whatNewData, setWhatNewData] = useState("");

  const shouldUpdateWeb = async () => {
    try {
      const apiResp = await apiFormatGetFullCtrl(
        "/api/Support/GetWebAppUpdate",
        ""
      );
      if (apiResp) {
        if (apiResp.data) {
          if (apiResp.data.errorCode === "200") {
            if (apiResp.data.data[0].Version) {
              if (
                apiResp.data.data[0].Version !==
                process.env.REACT_APP_SITE_VERSION
              ) {
                setWhatNewData(apiResp.data.data[0]);
                setShowWhatNewPopup(true);
              } else {
                setWhatNewData("");
                setShowWhatNewPopup(false);
              }
            } else {
            }
          } else {
          }
        } else {
        }
      } else {
      }
    } catch (err) { }
  };

  useEffect(() => {
    shouldUpdateWeb();
  }, []);

  return (
    <div>
      {showWhatNewPopup && whatNewData && (
        <WhatNewPopup data={whatNewData} close={setShowWhatNewPopup} />
      )}
      <div className={style.dashboardHeader}>
        {props.DashboardData.dashboard.data ? (
          <>
            <h2 className={`page-header ${style.display_flex}`}>
              Dashboard
            </h2>
          </>
        ) : (
          <>
            <div className={style.display_flex}>
              <h2 className={`skeleton ${style.fund}`}>{""}</h2>
            </div>
            <h3 className={`skeleton ${style.fundstyle}`}>{""}</h3>
          </>
        )}
      </div>

      <div className="row">
        <div className={` ${"col-6"} ${style.cardContainer} `}>
          <div className="row">
            {statusCards.map((item, ind) => (
              <div
                className={` ${"col-6"} ${style.cardContainer_card} `}
                key={ind}
              >
                <StatusCard
                  refreshDashBoard={() => {
                    refreshDashBoardFunc();
                  }}
                  setWalletLoadPopup={setWalletLoadPopup}
                  icon={item.icon}
                  count={item.count}
                  title={item.title}
                  k={ind}
                  data={props.DashboardData.dashboard.data}
                />
              </div>
            ))}
          </div>
        </div>

        <div className={` ${"col-6"} ${style.history} `}>
          <div className="card">
            <div className="card__header">
              {props.reports &&
                props.reports.LedgerReports &&
                props.reports.LedgerReports.data ? (
                <>
                  <h3 style={{ marginBottom: "20px" }}>History</h3>

                  <div className="card__body">
                    <Table
                      headData={latestOrders.header}
                      renderHead={(item, index) => renderOrderHead(item, index)}
                      bodyData={
                        props.reports.LedgerReports.data &&
                        props.reports.LedgerReports.data.slice(0, Number(10))
                      }
                      notShowTotalAmount={true}
                      renderBody={(item, index) => renderOrderBody(item, index)}
                      limit={10}
                      hideSearch={true}
                    />
                  </div>

                  <div className="card__footer">
                    <Link to="/distributor/LedgerReport">view all</Link>
                  </div>
                </>
              ) : (
                <>
                  {props.reports.error ? (
                    <>
                      <h3>History</h3>
                      <p className={style.error}>no data found!</p>
                    </>
                  ) : (
                    <>
                      <h3 className={`skeleton ${style.errors}`}></h3>

                      <h2 className={`skeleton ${style.errorStyle}`}></h2>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {walletLoadPopup && <WalletLoadPopup close={setWalletLoadPopup} />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    DashboardData: state.dashboardReducer,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLedgerReports: (date) => dispatch(actionCreators.getLedgerReports(date)),
    onGetDashboard: (navigate) =>
      dispatch(DashboardactionCreators.getDistributorDashBoard(navigate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
